import axios from "axios";

import { geoServerBaseUrl } from "./baseUrl";

import generate_uuid from "../validation/generate_uuid";

// Function to detect browser name
const get_browser_name = () => {
  const user_agent = navigator.userAgent;

  if (user_agent.includes("Firefox")) {
    return "Firefox";
  } else if (user_agent.includes("SamsungBrowser")) {
    return "Samsung";
  } else if (user_agent.includes("Opera") || user_agent.includes("OPR")) {
    return "Opera";
  } else if (user_agent.includes("Edge")) {
    return "Edge";
  } else if (user_agent.includes("Chrome")) {
    return "Chrome";
  } else if (user_agent.includes("Safari")) {
    return "Safari";
  } else {
    return "Unknown";
  }
};

// Function to detect OS name and version
const get_os_info = () => {
  const user_agent = navigator.userAgent;

  let os_name = "Unknown";
  let os_version = "";

  if (user_agent.includes("Windows NT")) {
    os_name = "Windows";
    const match = user_agent.match(/Windows NT ([\d.]+)/);
    if (match) {
      const version = match[1];
      switch (version) {
        case "10.0":
          os_version = "10";
          break;
        case "6.3":
          os_version = "8.1";
          break;
        case "6.2":
          os_version = "8";
          break;
        case "6.1":
          os_version = "7";
          break;
        case "6.0":
          os_version = "Vista";
          break;
        default:
          os_version = version;
      }
    }
  } else if (user_agent.includes("Mac OS X")) {
    os_name = "macOS";
    const match = user_agent.match(/Mac OS X ([\d_]+)/);
    if (match) {
      os_version = match[1].replace(/_/g, ".");
    }
  } else if (user_agent.includes("Android")) {
    os_name = "Android";
    const match = user_agent.match(/Android ([\d.]+)/);
    if (match) {
      os_version = match[1];
    }
  } else if (user_agent.includes("iPhone") || user_agent.includes("iPad")) {
    os_name = "iOS";
    const match = user_agent.match(/OS ([\d_]+)/);
    if (match) {
      os_version = match[1].replace(/_/g, ".");
    }
  } else if (user_agent.includes("Linux")) {
    os_name = "Linux";
  } else if (user_agent.includes("CrOS")) {
    os_name = "ChromeOS";
  }

  return { os_name, os_version };
};

// Updated activities_timeseries function
export const activities_timeseries = (action) => async (dispatch, getState) => {
  try {
    const state = getState();

    let id_visitor_local = localStorage.id_visitor;

    const { version } = state.auth;

    if (!id_visitor_local) {
      const { user } = state.auth;
      const user_id = user?._id || "guest";
      const browser_name = get_browser_name();
      const { os_name, os_version } = get_os_info();
      const uuid = generate_uuid();
      id_visitor_local = `${browser_name}_${os_name}_${os_version}_${uuid}_${user_id}`;
      localStorage.setItem("id_visitor", id_visitor_local);
    }

    dispatch({
      type: "set_loading_action",
      payload: "activities_timeseries",
    });

    const config = {
      headers: {
        accesstoken: localStorage?.token_mapid,
      },
    };

    const body = {
      id_visitor: id_visitor_local,
      page: window.location.pathname,
      domain: window.location.hostname,
      action: action,
      platform_version: version,
    };

    await axios.post(geoServerBaseUrl + "/activities_timeseries", body, config);

    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  } catch (error) {
    console.error("Error in activities_timeseries:", error);
    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  }
};

/*
body: action, duration_ms, layer_id
*/
export const post_activities = (body) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { version } = state.auth;
    let id_visitor_local = localStorage.id_visitor;

    if (!id_visitor_local) {
      const { user } = state.auth;
      const user_id = user?._id || "guest";
      const browser_name = get_browser_name();
      const { os_name, os_version } = get_os_info();
      const uuid = generate_uuid();
      id_visitor_local = `${browser_name}_${os_name}_${os_version}_${uuid}_${user_id}`;
      localStorage.setItem("id_visitor", id_visitor_local);
    }

    dispatch({
      type: "set_loading_action",
      payload: "activities_timeseries",
    });

    const config = {
      headers: {
        accesstoken: localStorage?.token_mapid,
      },
    };

    const body_post = {
      id_visitor: id_visitor_local,
      page: window.location.pathname,
      domain: window.location.hostname,
      platform_version: version,
      ...body,
    };

    await axios.post(
      geoServerBaseUrl + "/activities_timeseries",
      body_post,
      config,
    );

    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  } catch (error) {
    console.error("Error in activities_timeseries:", error);
    dispatch({
      type: "clear_loading_action",
      payload: "activities_timeseries",
    });
  }
};

/*
body: feedback_text, feedback_topic, action = "feedback"
*/
export const post_feedback = (body) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { version } = state.auth;

    let id_visitor_local = localStorage.id_visitor;

    if (!id_visitor_local) {
      const { user } = state.auth;
      const user_id = user?._id || "guest";
      const browser_name = get_browser_name();
      const { os_name, os_version } = get_os_info();
      const uuid = generate_uuid();
      id_visitor_local = `${browser_name}_${os_name}_${os_version}_${uuid}_${user_id}`;
      localStorage.setItem("id_visitor", id_visitor_local);
    }

    dispatch({
      type: "set_loading_action",
      payload: "post_feedback",
    });

    const config = {
      headers: {
        accesstoken: localStorage?.token_mapid,
      },
    };

    const body_post = {
      id_visitor: id_visitor_local,
      page: window.location.pathname,
      domain: window.location.hostname,
      platform_version: version,
      ...body,
    };

    const res = await axios.post(
      geoServerBaseUrl + "/activities_timeseries/feedback",
      body_post,
      config,
    );

    const data = res?.data || {};

    let { feedback_list } = state.properties;
    feedback_list = [data, ...feedback_list];

    dispatch({
      type: "set_value_properties",
      payload: {
        key: "feedback_list",
        value: feedback_list,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "post_feedback",
    });
  } catch (error) {
    console.error("Error in activities_timeseries:", error);
    dispatch({
      type: "clear_loading_action",
      payload: "post_feedback",
    });
  }
};

export const get_feedback_list_by_user = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_feedback_list_by_user",
    });
    const config = {
      headers: {
        accesstoken: localStorage?.token_mapid,
      },
    };
    const res = await axios.get(
      geoServerBaseUrl + "/activities_timeseries/get_feedback_list_by_user",
      config,
    );

    const feedback_list = res?.data || [];

    dispatch({
      type: "set_value_properties",
      payload: {
        key: "feedback_list",
        value: feedback_list,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "get_feedback_list_by_user",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_feedback_list_by_user",
    });
  }
};
